module.exports = __webpack_public_path__ + "img/SKMJ_check8.8a540551.png";